module.exports = __webpack_public_path__ + "static/img/img-cp8-1.a4dd7f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp8-1.png
// module id = EDnn
// module chunks = 0